import React from "react";
import { useLocation } from "react-router-dom";

const linearGradientBackgrounds = [
  "linear-gradient(135deg, #FF4081, #7C4DFF)",
  "linear-gradient(to right, #8BC34A, #009688)",
  "linear-gradient(to right, #7595FF, #FF8C8C)",
  "linear-gradient(135deg, #4A90E2, #B06AB3)",
  "linear-gradient(to right, #46CE8A, #004170)",
  "linear-gradient(to right, #CEC346, #702E00)",
];

const Slider = ({ isbusiness, loading }) => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const cardIndex = parseInt(searchParams.get('cardIndex')) || 0;

  const defaultBgStyle = {
    width: "100%",
    height: "461px",
    borderRadius: "8px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    textAlign: "center",
    color: "white",
    fontSize: "1.5rem",
    fontWeight: "bold",
    padding: "20px",
    boxSizing: "border-box",
    background: linearGradientBackgrounds[cardIndex % linearGradientBackgrounds.length],
  };
 
    if ( loading) {
    return (
      <div className="barber-slider">
        <div id="demo" className="carousel slide" data-bs-ride="carousel">
          <div className="carousel-indicators">
            <button
              type="button"
              data-bs-target="#demo"
              data-bs-slide-to={0}
              className="active"
            />
          </div>
          <div className="carousel-inner">
            <div className="carousel-item active">
              <div >
                {isbusiness?.business_name}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }



  // If there are no business images, show the gradient
  if (!isbusiness?.businessImage || isbusiness?.businessImage.length === 0) {
    return (
      <div className="barber-slider">
        <div id="demo" className="carousel slide" data-bs-ride="carousel">
          <div className="carousel-indicators">
            <button
              type="button"
              data-bs-target="#demo"
              data-bs-slide-to={0}
              className="active"
            />
          </div>
          <div className="carousel-inner">
            <div className="carousel-item active">
              <div style={defaultBgStyle}>
                {isbusiness?.business_name}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  // If there are business images, show them
  return (
    <div className="barber-slider">
      <div id="demo" className="carousel slide" data-bs-ride="carousel">
        <div className="carousel-indicators">
          {isbusiness?.businessImage?.map((item, index) => (
            <button
              type="button"
              data-bs-target="#demo"
              data-bs-slide-to={index}
              className={index === 0 ? "active" : ""}
              key={item?.id}
            />
          ))}
        </div>
        <div className="carousel-inner">
          {isbusiness?.businessImage?.map((item, index) => (
            <div
              className={`carousel-item ${index === 0 ? "active" : ""}`}
              key={item?.id}
            >
              <img
                src={item.image}
                alt="Los Angeles"
                className="d-block"
                style={{ width: "100%", height: "461px" }}
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Slider;
